import React from "react";
import Slider from "react-slick";
import { Typography, Button, Stack } from "@mui/material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../App.css";
import person1 from "../assets/Images/Person1.png";
import person2 from "../assets/Images/Person2.png";
import person3 from "../assets/Images/Person3.png";
import person4 from "../assets/Images/Person4.png";
import person5 from "../assets/Images/Person5.png";
import person6 from "../assets/Images/Person6.png";
import starFilled from "../assets/Images/starFilled.png";
import starEmpty from "../assets/Images/starEmpty.png";
import { isMobile } from "react-device-detect";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "darkGrey",
        height: "18px",
        width: "20px",
        borderRadius: "50%",
      }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "darkGrey",
        height: "18px",
        width: "20px",
        borderRadius: "50%",
      }}
      onClick={onClick}
    />
  );
}

const Testimonials = () => {
  const settings = {
    className: "slider variable-width",
    infinite: true,
    speed: 500,
    slidesToShow: isMobile ? 1 : 1,
    slidesToScroll: 1,
    arrows: isMobile ? false : false,
    variableWidth: true,
    // centerMode: isMobile ? true : false,
    // nextArrow: <SampleNextArrow />,
    // prevArrow: <SamplePrevArrow />,
  };
  return (
    <>
      <div
        className="how-it-works-container"
        style={{ paddingTop: "88px", paddingBottom: "80px" }}
      >
        <div style={{ width: "90%", margin: "auto" }}>
          <Typography
            variant="h5"
            component="h1"
            style={{
              marginTop: "30px",
              fontWeight: "700",
              fontSize: "48px",
              lineHeight: "56px",
              marginBottom: "30px",
              textAlign: isMobile ? "center" : "start",
            }}
          >
            Hear from people around you
          </Typography>
          <Slider {...settings}>
            <div>
              <div
                className="testimonialBox"
                style={isMobile ? { marginLeft: "20px" } : null}
              >
                <div
                  style={{
                    width: "90%",
                    margin: "auto",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                >
                  <Stack direction="row" spacing={2}>
                    <img src={person1} className="testimonialPerson" />
                    <Stack direction="column" spacing={1}>
                      <Typography variant="body1" className="testimonialTitle">
                        Fix My AC
                      </Typography>
                      <Stack direction="row" spacing={1}>
                        <img src={starFilled} className="star" />
                        <img src={starFilled} className="star" />
                        <img src={starFilled} className="star" />
                        <img src={starFilled} className="star" />
                        <img src={starEmpty} className="star" />
                      </Stack>
                    </Stack>
                  </Stack>
                  <Typography
                    variant="body1"
                    className="testimonialDescription"
                  >
                    What a great experience using Amaanat! I booked all of my
                    services through Amannat and never had any issues.
                  </Typography>
                  <Stack
                    className="mt-5"
                    direction="row"
                    alignItems="center"
                    spacing={2}
                  >
                    <Typography variant="body1" className="testimonialName">
                      Masson Mount
                    </Typography>
                    <Typography className="testimonialDate">
                      August 2022
                    </Typography>
                  </Stack>
                </div>
              </div>
            </div>
            <div>
              <div className="testimonialBox">
                <div
                  style={{
                    width: "90%",
                    margin: "auto",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                >
                  <Stack direction="row" spacing={2}>
                    <img src={person2} className="testimonialPerson" />
                    <Stack direction="column" spacing={1}>
                      <Typography variant="body1" className="testimonialTitle">
                        Fix My AC
                      </Typography>
                      <Stack direction="row" spacing={1}>
                        <img src={starFilled} className="star" />
                        <img src={starFilled} className="star" />
                        <img src={starFilled} className="star" />
                        <img src={starFilled} className="star" />
                        <img src={starEmpty} className="star" />
                      </Stack>
                    </Stack>
                  </Stack>
                  <Typography
                    variant="body1"
                    className="testimonialDescription"
                  >
                    What a great experience using Amaanat! I booked all of my
                    services through Amannat and never had any issues.
                  </Typography>
                  <Stack
                    className="mt-5"
                    direction="row"
                    alignItems="center"
                    spacing={2}
                  >
                    <Typography variant="body1" className="testimonialName">
                      Simon Cowell
                    </Typography>
                    <Typography className="testimonialDate">
                      August 2022
                    </Typography>
                  </Stack>
                </div>
              </div>
            </div>{" "}
            <div>
              <div className="testimonialBox">
                <div
                  style={{
                    width: "90%",
                    margin: "auto",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                >
                  <Stack direction="row" spacing={2}>
                    <img src={person3} className="testimonialPerson" />
                    <Stack direction="column" spacing={1}>
                      <Typography variant="body1" className="testimonialTitle">
                        Fix My AC
                      </Typography>
                      <Stack direction="row" spacing={1}>
                        <img src={starFilled} className="star" />
                        <img src={starFilled} className="star" />
                        <img src={starFilled} className="star" />
                        <img src={starFilled} className="star" />
                        <img src={starEmpty} className="star" />
                      </Stack>
                    </Stack>
                  </Stack>
                  <Typography
                    variant="body1"
                    className="testimonialDescription"
                  >
                    What a great experience using Amaanat! I booked all of my
                    services through Amannat and never had any issues.
                  </Typography>
                  <Stack
                    className="mt-5"
                    direction="row"
                    alignItems="center"
                    spacing={2}
                  >
                    <Typography variant="body1" className="testimonialName">
                      Taylor Swift
                    </Typography>
                    <Typography className="testimonialDate">
                      August 2022
                    </Typography>
                  </Stack>
                </div>
              </div>
            </div>{" "}
            <div>
              <div className="testimonialBox">
                <div
                  style={{
                    width: "90%",
                    margin: "auto",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                >
                  <Stack direction="row" spacing={2}>
                    <img src={person4} className="testimonialPerson" />
                    <Stack direction="column" spacing={1}>
                      <Typography variant="body1" className="testimonialTitle">
                        Fix My AC
                      </Typography>
                      <Stack direction="row" spacing={1}>
                        <img src={starFilled} className="star" />
                        <img src={starFilled} className="star" />
                        <img src={starFilled} className="star" />
                        <img src={starFilled} className="star" />
                        <img src={starEmpty} className="star" />
                      </Stack>
                    </Stack>
                  </Stack>
                  <Typography
                    variant="body1"
                    className="testimonialDescription"
                  >
                    What a great experience using Amaanat! I booked all of my
                    services through Amannat and never had any issues.
                  </Typography>
                  <Stack
                    className="mt-5"
                    direction="row"
                    alignItems="center"
                    spacing={2}
                  >
                    <Typography variant="body1" className="testimonialName">
                      Dominic Giles
                    </Typography>
                    <Typography className="testimonialDate">
                      August 2022
                    </Typography>
                  </Stack>
                </div>
              </div>
            </div>{" "}
            <div>
              <div className="testimonialBox">
                <div
                  style={{
                    width: "90%",
                    margin: "auto",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                >
                  <Stack direction="row" spacing={2}>
                    <img src={person5} className="testimonialPerson" />
                    <Stack direction="column" spacing={1}>
                      <Typography variant="body1" className="testimonialTitle">
                        Fix My AC
                      </Typography>
                      <Stack direction="row" spacing={1}>
                        <img src={starFilled} className="star" />
                        <img src={starFilled} className="star" />
                        <img src={starFilled} className="star" />
                        <img src={starFilled} className="star" />
                        <img src={starEmpty} className="star" />
                      </Stack>
                    </Stack>
                  </Stack>
                  <Typography
                    variant="body1"
                    className="testimonialDescription"
                  >
                    What a great experience using Amaanat! I booked all of my
                    services through Amannat and never had any issues.
                  </Typography>
                  <Stack
                    className="mt-5"
                    direction="row"
                    alignItems="center"
                    spacing={2}
                  >
                    <Typography variant="body1" className="testimonialName">
                      Sarah White
                    </Typography>
                    <Typography className="testimonialDate">
                      August 2022
                    </Typography>
                  </Stack>
                </div>
              </div>
            </div>{" "}
            <div>
              <div className="testimonialBox">
                <div
                  style={{
                    width: "90%",
                    margin: "auto",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                >
                  <Stack direction="row" spacing={2}>
                    <img src={person6} className="testimonialPerson" />
                    <Stack direction="column" spacing={1}>
                      <Typography variant="body1" className="testimonialTitle">
                        Fix My AC
                      </Typography>
                      <Stack direction="row" spacing={1}>
                        <img src={starFilled} className="star" />
                        <img src={starFilled} className="star" />
                        <img src={starFilled} className="star" />
                        <img src={starFilled} className="star" />
                        <img src={starEmpty} className="star" />
                      </Stack>
                    </Stack>
                  </Stack>
                  <Typography
                    variant="body1"
                    className="testimonialDescription"
                  >
                    What a great experience using Amaanat! I booked all of my
                    services through Amannat and never had any issues.
                  </Typography>
                  <Stack
                    className="mt-5"
                    direction="row"
                    alignItems="center"
                    spacing={2}
                  >
                    <Typography variant="body1" className="testimonialName">
                      Marcus Rashford
                    </Typography>
                    <Typography className="testimonialDate">
                      August 2022
                    </Typography>
                  </Stack>
                </div>
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </>
  );
};

export default Testimonials;
